const LEGACY_STORAGE_BUCKET = "sygc-88f80.appspot.com";
const CURRENT_STORAGE_BUCKET = "sygc-88f80.firebasestorage.app";

export function getConfiguredStorageBucket() {
  const configuredBucket = import.meta.env.VITE_STORAGE_BUCKET;

  if (!configuredBucket || configuredBucket === LEGACY_STORAGE_BUCKET) {
    return CURRENT_STORAGE_BUCKET;
  }

  return configuredBucket;
}

export function normalizeFirebaseStorageUrl(url?: string) {
  const storageBucket = getConfiguredStorageBucket();
  if (!url) return url;

  try {
    const parsed = new URL(url);
    const pathParts = parsed.pathname.split("/");
    const bucketIndex = pathParts.findIndex(part => part === "b");

    if (bucketIndex >= 0 && pathParts[bucketIndex + 1]) {
      pathParts[bucketIndex + 1] = storageBucket;
      parsed.pathname = pathParts.join("/");
      return parsed.toString();
    }
  } catch {
    return url;
  }

  return url;
}
